
const state = {
    error: {
        code: '',
        message: '',
        status: ''
    }
  }

const mutations = {
    SET_ERROR(state, error){
        state.error = error;
    }
}

const actions = {
    setError({ commit }, error){
        commit('SET_ERROR', error.values);
    }
}

export default{
    namespaced: true,//用于全局引用此文件里的方法时标识这个文件名，解决命名冲突问题
    state,
    mutations,
    actions
}